<template>
	<div>
		<h1>Support Requests - Summary Stats</h1>
		<v-card>
			<v-card-title>
				Support Requests by Issue Type
			</v-card-title>
			<v-data-table
				:headers="summaryData.byTopic.headers"
				:items="summaryData.byTopic.items"
				:items-per-page="25"
			>
				<template v-slot:item.percent="{ item }">
					<span>{{ Number(item.percent).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:1}) }}</span>
				</template>
			</v-data-table>
		</v-card>
		<v-card>
			<v-card-title>
				Support Requests by Contact Method
			</v-card-title>
			<v-data-table
				:headers="summaryData.byContactType.headers"
				:items="summaryData.byContactType.items"
				:items-per-page="25"
			>
				<template v-slot:item.percent="{ item }">
					<span>{{ Number(item.percent).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:1}) }}</span>
				</template>
			</v-data-table>
		</v-card>
		<v-card>
			<v-card-title>
				Support Requests by Agency
			</v-card-title>
			<v-data-table
				:headers="summaryData.byAgency.headers"
				:items="summaryData.byAgency.items"
				:items-per-page="25"
			>
				<template v-slot:item.percent="{ item }">
					<span>{{ Number(item.percent).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:1}) }}</span>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
import router from "@/router";
import { officeManagementService } from '@/services/officeManagementService.js';

export default {
	name: 'SupportRequestSummary',
	data: function () {
		return {
			summaryData: {
				byTopic: {
					headers: [
							{ text: 'Problem Type', value: 'value' },
							{ text: 'Count', value: 'count' },
							{ text: 'Percent', value: 'percent' }
						],
					items: []
				},
				byContactType: {
					headers: [
							{ text: 'Contact Method', value: 'value' },
							{ text: 'Count', value: 'count' },
							{ text: 'Percent', value: 'percent' }
						],
					items: []
				},
				byAgency: {
					headers: [
							{ text: 'Agency', value: 'agency' },
							{ text: 'Program', value: 'program' },
							{ text: 'Field', value: 'field' },
							{ text: 'Branch', value: 'branch' },
							{ text: 'OfficeName', value: 'officeName' },
							{ text: 'Count', value: 'count' },
							{ text: 'Percent', value: 'percent' }
						],
					items: []
				}
			}
		}
	},
	methods: {
		onTopicItemClick: function (key) {
			router.push({ name: 'admin.supportRequestSearch', params: { topicType: key } });
		},
		onContactTypeItemClick: function (key) {
			router.push({ name: 'admin.supportRequestSearch', params: { contactType: key } });
		},
		onAgencyItemClick: function (key) {
			router.push({ name: 'admin.supportRequestSearch', params: { agency: key } });
		}
	},
	mounted () {
		let me = this;
		officeManagementService.getSupportRequestsSummary().then(function (resp) {
			me.summaryData.byTopic.items = resp.data.topicSummary;
			me.summaryData.byContactType.items = resp.data.contactTypeSummary;
			me.summaryData.byAgency.items = resp.data.agencySummary;
		});
	}
}
</script>

<style>
</style>
